import {
  getGuestScheduleAuthMode,
  isGuestLoginCheckoutPending,
  isGuestScheduleLoginAuth,
  shouldSkipGuestHealthTeamCheck
} from './scheduleGuestFlow'

const DEBUG_PREFIX = '[guest-login-flow]'

export const logGuestLoginFlow = (eventName, extra = {}) => {
  console.info(DEBUG_PREFIX, eventName, {
    guest_auth_mode: getGuestScheduleAuthMode(),
    guest_login_checkout_pending: isGuestLoginCheckoutPending(),
    is_guest_schedule_login_auth: isGuestScheduleLoginAuth(),
    skip_health_team_check: shouldSkipGuestHealthTeamCheck(),
    ...extra
  })
}

export const GUEST_LOGIN_CONTINUATION_SKIP_REASONS = {
  AUTH_LOADING: 'auth_loading',
  NOT_AUTHENTICATED: 'not_authenticated',
  NOT_GUEST_FLOW_OR_PENDING: 'not_guest_flow_or_pending',
  NOT_GUEST_FLOW_PATH: 'not_guest_flow_path',
  NOT_CONTINUATION_PATH: 'not_continuation_path',
  LOGIN_CONTINUATION_NOT_PENDING: 'login_continuation_not_pending',
  ALREADY_HANDLED: 'already_handled',
  MISSING_CHECKOUT_SELECTION: 'missing_checkout_selection',
  ONBOARDING_INCOMPLETE: 'onboarding_incomplete',
  ONBOARDING_VERIFY_FAILED: 'onboarding_verify_failed'
}

export const GUEST_LOGIN_HEALTH_TEAM_SKIP_REASONS = {
  NOT_LOGIN_AUTH: 'not_login_auth',
  SKIP_HEALTH_TEAM_FLAG: 'skip_health_team_flag',
  NO_DOCTOR_ID: 'no_doctor_id',
  MISSING_PATIENTS_API_BASE_URL: 'missing_patients_api_base_url',
  MISSING_DOCTOR_OR_SERVICE: 'missing_doctor_or_service'
}

export const GUEST_LOGIN_VALIDATION_FAILURE_REASONS = {
  MISSING_API_BASE_URL: 'missing_api_base_url',
  MISSING_AUTH_TOKEN: 'missing_auth_token',
  HTTP_ERROR: 'http_error',
  API_SUCCESS_FALSE: 'api_success_false',
  VALIDATION_DATA_NULL: 'validation_data_null',
  NETWORK_ERROR: 'network_error',
  NO_RESPONSE: 'no_response'
}

export const logGuestLoginFlowError = (eventName, extra = {}) => {
  console.error(DEBUG_PREFIX, eventName, {
    guest_auth_mode: getGuestScheduleAuthMode(),
    guest_login_checkout_pending: isGuestLoginCheckoutPending(),
    is_guest_schedule_login_auth: isGuestScheduleLoginAuth(),
    skip_health_team_check: shouldSkipGuestHealthTeamCheck(),
    ...extra
  })
}
